import type { AiConfig } from '../pages/content-management/helpdesk/manage';

export const mockAiConfig: AiConfig = {
    modelName: 'gpt-4-turbo',
    temperature: 0.7,
    maxTokens: 2048,
    topP: 0.95,
    frequencyPenalty: 0.5,
    presencePenalty: 0.5,
    documentSearchEnabled: true,
    webSearchEnabled: false,
    feedbackCollection: true
}; 